import React from 'react'
import { graphql } from 'gatsby'
import TeamPage from '../../layouts/team-page'

export const query = graphql`
  query {
    portrait: file(relativePath: { eq: "team/portrait_anthony.jpg" }) {
      ...textContainerWide
    }
  }
`

export default ({ data }) => (
  <TeamPage
    slug="anthony-wiktor"
    portrait={data.portrait.childImageSharp.fluid}
  />
)
